export default __webpack_public_path__ + "static/JA2-5c451facb6ce8e02c4d7b3b7042534a5.png";